import React from "react";

const Success = ({aide, imposable}) => {
    let estImposable = (imposable === "oui");

    return (
        <div className="alert alert-success" id="photovoltaique-succes">
        <div>En fonction des informations saisies ci-dessus, l’estimation de l’aide du Département à l'acquisition et installation d'équipements solaires pour la production d'électricité est :</div>
        <div className="montant-resultat text-center"style={{ fontSize: "x-large" }}><strong>{aide} €</strong> *</div>
        <div className="complement text-center">* Attention, les montants affichés sont indicatifs et devront être validés par nos services lors de l'instruction de votre dossier.</div>
        { !estImposable && <div className="text-center">Si vous faites partie d'un foyer non imposable, le dernier avis d'imposition du foyer vous sera demandé lors de la création de la demande</div>}
    </div>
    )
}


export default Success